export default {
  namespaced: true,
  state: {
    modulos: [],

    dataModulosNombres: [],
    dataModulosIconos: [],

    dataSeccionesNombres: [],
    dataSeccionesReferencias: [],
    dataSeccionesModulos: [],

    //datatables
    dataDatatableModulos: [],
    dataDatatableModulosFiltrada: [],

    //
    dataDatatableSecciones: [],
    dataDatatableSeccionesFiltrada: [],

    //
    dataDatatableSubSecciones: [],
    dataDatatableSubSeccionesFiltrada: [],

    visibleModalEditarSubSeccion: false,
  },

  mutations: {
    setModulos(state, payload) {
      state.modulos = payload;
    },

    //
    setDataModulosNombres(state, payload) {
      state.dataModulosNombres = payload;
    },
    setDataModulosIconos(state, payload) {
      state.dataModulosIconos = payload;
    },

    setDataSeccionesNombres(state, payload) {
      state.dataSeccionesNombres = payload;
    },
    setDataSeccionesReferencias(state, payload) {
      state.dataSeccionesReferencias = payload;
    },
    setDataSeccionesModulos(state, payload) {
      state.dataSeccionesModulos = payload;
    },

    //datatables
    setDataModulos(state, payload) {
      state.dataDatatableModulos = payload;
      state.dataDatatableModulosFiltrada = payload;
    },

    filterDataModulos(state, payload) {
      state.dataDatatableModulosFiltrada = state.dataDatatableModulos;
      state.dataDatatableModulosFiltrada = payload;
    },

    limpiarDataModulos(state) {
      state.dataDatatableModulosFiltrada = state.dataDatatableModulos;
    },

    //
    setDataSecciones(state, payload) {
      state.dataDatatableSecciones = payload;
      state.dataDatatableSeccionesFiltrada = payload;
    },

    filterDataSecciones(state, payload) {
      state.dataDatatableSeccionesFiltrada = state.dataDatatableSecciones;
      state.dataDatatableSeccionesFiltrada = payload;
    },

    limpiarDataSecciones(state) {
      state.dataDatatableSeccionesFiltrada = state.dataDatatableSecciones;
    },

    //
    setDataSubSecciones(state, payload) {
      state.dataDatatableSubSecciones = payload;
      state.dataDatatableSubSeccionesFiltrada = payload;
    },

    filterDataSubSecciones(state, payload) {
      state.dataDatatableSubSeccionesFiltrada = state.dataDatatableSecciones;
      state.dataDatatableSubSeccionesFiltrada = payload;
    },

    limpiarDataSubSecciones(state) {
      state.dataDatatableSubSeccionesFiltrada = state.dataDatatableSecciones;
    },

    setVisibleModalEditarSubSeccion(state, payload) {
      state.visibleModalEditarSubSeccion = payload;
    },
  },

  actions: {
    actionSetModulos({ commit }, data) {
      commit("setModulos", data);
    },

    //
    actionSetDataModulosNombres({ commit }, data) {
      commit("setDataModulosNombres", data);
    },
    actionSetDataModulosIconos({ commit }, data) {
      commit("setDataModulosIconos", data);
    },

    actionSetDataSeccionesNombres({ commit }, data) {
      commit("setDataSeccionesNombres", data);
    },
    actionSetDataSeccionesReferencias({ commit }, data) {
      commit("setDataSeccionesReferencias", data);
    },
    actionSetDataSeccionesModulos({ commit }, data) {
      commit("setDataSeccionesModulos", data);
    },

    //datatables
    actionSetDataModulos({ commit }, data) {
      commit("setDataModulos", data);
    },

    actionFilterDataModulos({ commit }, data) {
      commit("filterDataModulos", data);
    },

    actionLimpiarFilterDataModulos({ commit }) {
      commit("limpiarDataModulos");
    },

    //
    actionSetDataSecciones({ commit }, data) {
      commit("setDataSecciones", data);
    },

    actionFilterDataSecciones({ commit }, data) {
      commit("filterDataSecciones", data);
    },

    actionLimpiarFilterDataSecciones({ commit }) {
      commit("limpiarDataSecciones");
    },

    //
    actionSetDataSubSecciones({ commit }, data) {
      commit("setDataSubSecciones", data);
    },

    actionFilterDataSubSecciones({ commit }, data) {
      commit("filterDataSubSecciones", data);
    },

    actionLimpiarFilterDataSubSecciones({ commit }) {
      commit("limpiarDataSubSecciones");
    },

    ActionSetVisibleModalEditarSubSeccion({ commit }, data) {
      commit("setVisibleModalEditarSubSeccion", data);
    },
  },
};
